import { createSlice } from '@reduxjs/toolkit';
import { AppState, HeaderSlice } from '../interfaces/store.interface';

export const initialState: HeaderSlice = {
  logo: '',
  language: 'EN',
};

export const header = 'header';

export const headerSlice = createSlice({
  name: header,
  initialState,
  reducers: {
    // NOTE: data massaging for address data can go in here. Mai API calls should go in here
    toggleLanguage: (state, action) => {
      state.language = action.payload === 'EN' ? 'ES' : 'no language detected';
    },
  },
});

// state actions can be exported here
export const { toggleLanguage } = headerSlice.actions;

export default headerSlice.reducer;

// state getters can be written & exported here
export const getHeaderLanguage = (state: AppState) => state.header.language;
